/**
 * Deterministic sequence pill colors.
 *
 * Sequences have no stored color — a sequence's pill color is derived from
 * its id, so the same sequence renders the same color everywhere, for every
 * user, across sessions, with no backend column. Palette hues match the
 * muted-pastel range used elsewhere on the dark theme (see
 * `features/search/lib/colors.ts`).
 */
export const SEQUENCE_PILL_PALETTE = [
  "#c8a86e",
  "#7fcaff",
  "#b089ff",
  "#69d9a0",
  "#ff9e6c",
  "#e07070",
  "#ff6b8a",
  "#5bc0de",
  "#ffd966",
  "#a1e3a1",
] as const;

export function sequenceColor(sequenceId: string): string {
  let h = 0;
  for (let i = 0; i < sequenceId.length; i++) {
    h = ((h << 5) - h + sequenceId.charCodeAt(i)) | 0;
  }
  return SEQUENCE_PILL_PALETTE[(h >>> 0) % SEQUENCE_PILL_PALETTE.length];
}
